<script lang="ts">
    import {getSutorReportsOptimisationContext} from '../lib/sutor-reports-optimisation-context';
    import KpPageableSearchResults from '../../../../../../search/kp-search-results/KpPageableSearchResults.svelte';
    import KpBarebonesTable from 'shared/ui-widgets/table/barebones/KpBarebonesTable.svelte';
    import ReportOptimisationUserItem from './ReportOptimisationUserItem.svelte';
    import KpStaticSearchContext from 'src/features/search/kp-search-context/KpStaticSearchContext.svelte';

    const context = getSutorReportsOptimisationContext();
</script>

<KpStaticSearchContext searchManager="{context.usersListSearchContext}"
                       let:searchManager>

    <KpPageableSearchResults pagination="{searchManager.getPagination()}" let:paginationData>
        <KpBarebonesTable fontSize="12px">
            <tr slot="header">
                <th>Pracovník</th>
                <th>Zakázka</th>
                <th>Datum</th>
                <th>Vhodný k optimalizaci</th>
            </tr>

            <svelte:fragment slot="body">
                {#each paginationData.items as record(record.id)}
                    <ReportOptimisationUserItem {record}/>
                {/each}
            </svelte:fragment>
        </KpBarebonesTable>
    </KpPageableSearchResults>
</KpStaticSearchContext>